/* eslint-disable import/named */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import type {ChangeEvent} from 'react';
import {useState} from 'react';
import {Form, InputGroup, Button} from 'react-bootstrap';
import {PopoverComponent} from 'components/PopoverComponent';
import type {IPccRuleFormDynamic, IFlowInfoForm} from 'interfaces';
import FieldSetSumma from 'components/Custom/FieldGroup';

import './styles.css';

interface SelectionItemProps {
	formData: IPccRuleFormDynamic;
	updateRuleData: (
		keyForm: string,
		path: string[],
		value: string,
		type: string,
		checked: boolean,
		key: number | string | null,
	) => void;
	onObserver: (isValid: boolean) => void;
	onAddFlowInfo: () => void;
	onDeleteFlowInfo: (tag: string, id: string) => void;
}

// validations fields
const validationRules = {
	maxbrUl: {
		regex: /^\d+\s(?:bps|Kbps|Mbps|Gbps|Tbps)$/,
		errorMessage:
			'The field is invalid, only the following formats are allowed, for example: 128 bps|Kbps|Mbps|Gbps|Tbps.',
	},
	maxbrDl: {
		regex: /^\d+\s(?:bps|Kbps|Mbps|Gbps|Tbps)$/,
		errorMessage:
			'The field is invalid, only the following formats are allowed, for example: 128 bps|Kbps|Mbps|Gbps|Tbps.',
	},
	gbrUl: {
		regex: /^\d+\s(?:bps|Kbps|Mbps|Gbps|Tbps)$/,
		errorMessage:
			'The field is invalid, only the following formats are allowed, for example: 128 bps|Kbps|Mbps|Gbps|Tbps.',
	},
	gbrDl: {
		regex: /^\d+\s(?:bps|Kbps|Mbps|Gbps|Tbps)$/,
		errorMessage:
			'The field is invalid, only the following formats are allowed, for example: 128 bps|Kbps|Mbps|Gbps|Tbps.',
	},
};

const DynamicPccRuleForm = ({
	formData,
	updateRuleData,
	onObserver,
	onAddFlowInfo,
	onDeleteFlowInfo,
}: SelectionItemProps) => {
	const [isValid, setIsValid] = useState({
		uplink: true,
		downlink: true,
		maxbrUl: true,
		maxbrDl: true,
		gbrUl: true,
		gbrDl: true,
	});

	/**
	 * The function handles changes in form input fields, updating state based on the type of input.
	 * @param e - The parameter "e" is of type ChangeEvent<HTMLInputElement>, which is an event object
	 * that is triggered when the value of an input element changes. It contains information about the
	 * input element that triggered the event, such as its name, value, type, and whether it is checked
	 * (if it is a
	 */
	const handleChange = (
		path: string[],
		e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
		key?: number | string | null,
	) => {
		const {value, type} = e.target;
		const checked =
			type === 'checkbox' && 'checked' in e.target
				? (e.target as HTMLInputElement).checked
				: false;
		updateRuleData(formData.id, path, value, type, checked, key ?? null);
	};

	const handleRemove = (tag: string, id: string) => {
		onDeleteFlowInfo(tag, id);
	};

	return (
		<>
			{/* 1 row */}
			<div
				className="text-bg-light mb-2 &gt; border rounded-3 px-4 pb-3"
				style={{height: '100%', overflowY: 'auto'}}>
				<div className="centered-div mb-2">
					<label htmlFor="filter-list-group" className="centered-label">
						Labels selected
					</label>
				</div>
				{/* 1 row */}
				{formData?.precedence?.active && (
					<div className="col-xs-12 col-lg-6">
						<label htmlFor="idRulePrece">Precedence</label>
						<InputGroup className="mb-3">
							<Form.Control
								type="number"
								name="precedence"
								value={formData?.precedence?.value}
								required={formData?.precedence?.active}
								onChange={e => handleChange(['precedence'], e)}
								aria-label="precedence"
							/>
						</InputGroup>
					</div>
				)}

				{(formData?.qosData?._5qi?.active ||
					formData?.qosData?.maxbrUl?.active ||
					formData?.qosData?.maxbrDl?.active ||
					formData?.qosData?.gbrUl?.active ||
					formData?.qosData?.gbrDl?.active ||
					formData?.qosData?.arp?.priorityLevel?.active ||
					formData?.qosData?.arp?.preemptCap?.active ||
					formData?.qosData?.arp?.preemptVuln?.active) && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>QoS Data</b>
						</div>
						{formData?.qosData?._5qi?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idRuleQoSData5qi">
									5qi
									<PopoverComponent classes="ml-1" iconSize="1rem">
										<div>
											<h5>5G QoS Identifier (5QI)</h5>
											<p>Similar to the QCI value used for LTE</p>
										</div>
									</PopoverComponent>
								</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="_5qi"
										value={formData?.qosData?._5qi?.value}
										required={formData?.qosData?._5qi?.active}
										onChange={e => handleChange(['qosData', '_5qi'], e)}
										aria-label="_5qi"
									/>
								</InputGroup>
							</div>
						)}

						{formData?.qosData?.maxbrUl?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idRuleQoSDataMBRU">Max BR Uplink</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="maxbrUl"
										value={formData?.qosData?.maxbrUl?.value}
										required={formData?.qosData?.maxbrUl?.active}
										onChange={e => handleChange(['qosData', 'maxbrUl'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value.slice(0, 10);
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										placeholder="E.g. 128 Kbps"
										aria-label="maxbrUl"
										className={!isValid.maxbrUl ? 'is-invalid' : ''}
									/>
									{!isValid.maxbrUl && (
										<div className="invalid-feedback">
											{validationRules?.maxbrUl?.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{formData?.qosData?.maxbrDl?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idRuleQoSDataMBRD">Max BR Downlink</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="maxbrDl"
										value={formData?.qosData?.maxbrDl?.value}
										required={formData?.qosData?.maxbrDl?.active}
										onChange={e => handleChange(['qosData', 'maxbrDl'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value.slice(0, 10);
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										placeholder="E.g. 128 Kbps"
										aria-label="maxbrDl"
										className={!isValid.maxbrDl ? 'is-invalid' : ''}
									/>
									{!isValid.maxbrDl && (
										<div className="invalid-feedback">
											{validationRules?.maxbrDl?.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{formData?.qosData?.gbrUl?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idRuleQoSDataGUU">Guaranteed BR Uplink</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="gbrUl"
										value={formData?.qosData?.gbrUl?.value}
										required={formData?.qosData?.gbrUl?.active}
										onChange={e => handleChange(['qosData', 'gbrUl'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLTextAreaElement;
											const val = target.value.slice(0, 10);
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										placeholder="E.g. 128 Kbps"
										aria-label="gbrUl"
										className={!isValid.gbrUl ? 'is-invalid' : ''}
									/>
									{!isValid.gbrUl && (
										<div className="invalid-feedback">
											{validationRules?.gbrUl?.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{formData?.qosData?.gbrDl?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idRuleQoSDataGUD">Guaranteed BR Downlink</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="gbrDl"
										value={formData?.qosData?.gbrDl?.value}
										required={formData?.qosData?.gbrDl?.active}
										onChange={e => handleChange(['qosData', 'gbrDl'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value.slice(0, 10);
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										placeholder="E.g. 128 Kbps"
										aria-label="gbrDl"
										className={!isValid.gbrDl ? 'is-invalid' : ''}
									/>
									{!isValid.gbrDl && (
										<div className="invalid-feedback">
											{validationRules?.gbrDl?.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{(formData?.qosData?.arp?.priorityLevel?.active ||
							formData?.qosData?.arp?.preemptCap?.active ||
							formData?.qosData?.arp?.preemptVuln?.active) && (
							<FieldSetSumma title="ARP">
								<div className="row">
									{formData?.qosData?.arp?.priorityLevel?.active && (
										<div className="col-xs-12 col-lg-2">
											<label htmlFor="idActionPCCARPPriorityLevel">
												Priority Level
											</label>
											<InputGroup className="mb-3">
												<Form.Control
													type="number"
													onInput={e => {
														const target = e.target as HTMLInputElement;
														target.value = target.value.slice(0, 15);
													}}
													name="priorityLevel"
													value={formData?.qosData?.arp?.priorityLevel?.value}
													required={
														formData?.qosData?.arp?.priorityLevel?.active
													}
													onChange={e =>
														handleChange(['qosData', 'arp', 'priorityLevel'], e)
													}
													aria-label="priorityLevel"
												/>
											</InputGroup>
										</div>
									)}

									{formData?.qosData?.arp?.preemptCap?.active && (
										<div className="col-xs-12 col-lg-5">
											<label htmlFor="idActionPCCARPPreEmptionCap">
												Pre-emption Capability
											</label>
											<InputGroup className="mb-3">
												<Form.Select
													name="preemptCap"
													value={formData?.qosData?.arp?.preemptCap?.value}
													required={formData?.qosData?.arp?.preemptCap?.active}
													onChange={e =>
														handleChange(['qosData', 'arp', 'preemptCap'], e)
													}
													aria-label="preemptCap">
													<option disabled value="">
														Select...
													</option>
													<option value="MAY_PREEMPTABLE">
														MAY_PREEMPTABLE
													</option>
													<option value="NOT_PREEMPTABLE">
														NOT_PREEMPTABLE
													</option>
												</Form.Select>
											</InputGroup>
										</div>
									)}

									{formData?.qosData?.arp?.preemptVuln?.active && (
										<div className="col-xs-12 col-lg-5">
											<label htmlFor="idActionPCCARPPreEmptionVulne">
												Pre-emption Vulnerability
											</label>
											<InputGroup className="mb-3">
												<Form.Select
													name="preemptVuln"
													value={formData?.qosData?.arp?.preemptVuln?.value}
													required={formData?.qosData?.arp?.preemptVuln?.active}
													onChange={e =>
														handleChange(['qosData', 'arp', 'preemptVuln'], e)
													}
													aria-label="preemptVuln">
													<option disabled value="">
														Select...
													</option>
													<option value="NOT_PREEMPTABLE">
														NOT_PREEMPTABLE
													</option>
													<option value="PREEMPTABLE">PREEMPTABLE</option>
												</Form.Select>
											</InputGroup>
										</div>
									)}
								</div>
							</FieldSetSumma>
						)}
					</div>
				)}

				{(formData?.chargingData?.online?.active ||
					formData?.chargingData?.offline?.active ||
					formData?.chargingData?.ratingGroup?.active ||
					formData?.chargingData?.afChargingIdentifier?.active ||
					formData?.chargingData?.serviceId?.active ||
					formData?.chargingData?.reportingLevel?.active) && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Charging Data</b>
						</div>
						{formData?.chargingData?.online?.active && (
							<div className="col-xs-12 col-lg-3">
								<label
									htmlFor="idActionPCCChargingOnline"
									className="font-weight-bold">
									Online
								</label>
								<InputGroup className="mb-3">
									<Form.Check
										name="online"
										checked={formData?.chargingData?.online?.value}
										required={formData?.chargingData?.online?.active}
										onChange={e => handleChange(['chargingData', 'online'], e)}
										type="switch"
										data-switch="true"
										id="custom-switch-chargingData"
										className="custom-switch-lg custom-switch-position-relative"
									/>
								</InputGroup>
							</div>
						)}

						{formData?.chargingData?.offline?.active && (
							<div className="col-xs-12 col-lg-3">
								<label
									htmlFor="idActionPCCChargingOffline"
									className="font-weight-bold">
									Offline
								</label>
								<InputGroup className="mb-3">
									<Form.Check
										name="online"
										checked={formData?.chargingData?.offline?.value}
										required={formData?.chargingData?.offline?.active}
										onChange={e => handleChange(['chargingData', 'offline'], e)}
										type="switch"
										data-switch="true"
										id="custom-switch-chargingData"
										className="custom-switch-lg custom-switch-position-relative"
									/>
								</InputGroup>
							</div>
						)}

						{formData?.chargingData?.ratingGroup?.active && (
							<div className="col-xs-6 col-lg-3">
								<label htmlFor="idActionPCCChargingRating">Rating Group</label>
								<InputGroup className="mb-3">
									<Form.Control
										type="number"
										name="ratingGroup"
										value={formData?.chargingData?.ratingGroup?.value}
										required={formData?.chargingData?.ratingGroup?.active}
										onChange={e =>
											handleChange(['chargingData', 'ratingGroup'], e)
										}
										aria-label="ratingGroup"
									/>
								</InputGroup>
							</div>
						)}

						{formData?.chargingData?.serviceId?.active && (
							<div className="col-xs-6 col-lg-3">
								<label htmlFor="idActionPCCChargingService">Service Id</label>
								<InputGroup className="mb-3">
									<Form.Control
										type="number"
										name="serviceId"
										value={formData?.chargingData?.serviceId?.value}
										required={formData?.chargingData?.serviceId?.active}
										onChange={e =>
											handleChange(['chargingData', 'serviceId'], e)
										}
										aria-label="serviceId"
									/>
								</InputGroup>
							</div>
						)}

						{formData?.chargingData?.afChargingIdentifier?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idActionPCCChargingAf">
									Af Charging Identifier
								</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="afChargingIdentifier"
										value={formData?.chargingData?.afChargingIdentifier?.value}
										required={
											formData?.chargingData?.afChargingIdentifier?.active
										}
										onChange={e =>
											handleChange(['chargingData', 'afChargingIdentifier'], e)
										}
										aria-label="afChargingIdentifier"
									/>
								</InputGroup>
							</div>
						)}

						{formData?.chargingData?.reportingLevel?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idActionPCCChargingReport">
									Reporting Level
								</label>
								<InputGroup className="mb-3">
									<Form.Select
										name="reportingLevel"
										value={formData?.chargingData?.reportingLevel?.value}
										required={formData?.chargingData?.reportingLevel?.active}
										onChange={e =>
											handleChange(['chargingData', 'reportingLevel'], e)
										}
										aria-label="reportingLevel">
										<option disabled value="">
											Select...
										</option>
										<option value="SERVICE_IDENTIFIER_LEVEL">
											SERVICE_IDENTIFIER_LEVEL
										</option>
										<option value="RATING_GROUP_LEVEL">
											RATING_GROUP_LEVEL
										</option>
										<option value="SPONSORED_CONNECTIVITY_LEVEL">
											SPONSORED_CONNECTIVITY_LEVEL
										</option>
									</Form.Select>
								</InputGroup>
							</div>
						)}
					</div>
				)}

				{formData?.hasFlowInfo && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Flow Information</b>
						</div>
						<div className="col m-3">
							<Button
								type="button"
								variant="secondary"
								className="btn btn-labeled btn-sm z-index mr-1"
								onClick={onAddFlowInfo}>
								<span className="btn-label mr-2">
									<i className="bi-1 bi-plus" />
								</span>
								Add Flow Info
							</Button>
						</div>
						{formData?.flowInfo?.map(
							(flowInfo: IFlowInfoForm, index: number) => (
								<FieldSetSumma title={`Flow Info #${index + 1}`} key={index}>
									<div>
										<button
											onClick={() => handleRemove('flowInfo', flowInfo.id)}
											type="button"
											className="border-0 bg-transparent d-inline position-absolute top-0 end-0 pr-2 mt-n3"
											data-bs-toggle="collapse"
											data-bs-target="#newflowrule1"
											aria-expanded="true">
											<i
												className="bi-1 bi-trash3-fill invalid-color"
												title=""
												data-toggle="tooltip"
												data-original-title="Delete"
											/>
										</button>
									</div>
									<div className="row">
										<div className="col-xs-12 col-lg-6">
											<label htmlFor="idActionFlowInfoDescrip">
												Flow Description
											</label>
											<InputGroup className="mb-3">
												<Form.Control
													name="flowDescription"
													value={flowInfo?.flowDescription?.value}
													onChange={e =>
														handleChange(
															['flowInfo', 'flowDescription'],
															e,
															flowInfo.id,
														)
													}
													aria-label="flowDescription"
												/>
											</InputGroup>
										</div>
										<div className="col-xs-12 col-lg-6">
											<label htmlFor="idActionFlowInfoDirection">
												Flow Direction
											</label>
											<InputGroup className="mb-3">
												<Form.Select
													name="flowDirection"
													value={flowInfo?.flowDirection?.value}
													onChange={e =>
														handleChange(
															['flowInfo', 'flowDirection'],
															e,
															flowInfo.id,
														)
													}
													aria-label="flowDirection">
													<option disabled value="">
														Select...
													</option>
													<option value="UNSPECIFIED">UNSPECIFIED</option>
													<option value="DOWNLINK">DOWNLINK</option>
													<option value="UPLINK">UPLINK</option>
													<option value="BIDIRECTIONAL">BIDIRECTIONAL</option>
												</Form.Select>
											</InputGroup>
										</div>
										<div className="col-xs-12 col-lg-6">
											<label htmlFor="idActionFlowInfoTOSTrafficClass">
												TOS Traffic Class
											</label>
											<InputGroup className="mb-3">
												<Form.Control
													name="tosTrafficClass"
													value={flowInfo?.tosTrafficClass?.value}
													onChange={e =>
														handleChange(
															['flowInfo', 'tosTrafficClass'],
															e,
															flowInfo.id,
														)
													}
													aria-label="tosTrafficClass"
												/>
											</InputGroup>
										</div>
									</div>
								</FieldSetSumma>
							),
						)}
					</div>
				)}
			</div>
			{/* end 1 row*/}
		</>
	);
};

export default DynamicPccRuleForm;
